import { forwardRef } from 'react';
import BaseQRCode from 'react-qr-code';

import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexProps } from '../Flex/index.js';

export type QRCodeElement = HTMLDivElement;
export interface QRCodeProps extends FlexProps {
  value: string;
  size?: number;
}

/**
 * Responsive QRCode component.
 */
export const QRCode = styled(
  forwardRef<QRCodeElement, QRCodeProps>(({ value, size = 256, ...restProps }, ref) => {
    return (
      <Flex ref={ref} {...restProps}>
        <a href={value} rel="noreferrer" target="_blank">
          <BaseQRCode
            size={size}
            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
            value={value}
            viewBox={`0 0 ${size} ${size}`}
          />
        </a>
      </Flex>
    );
  })
).withConfig({
  displayName: 'QRCode',
})`
  background: white;
  height: auto;
  margin: 0 auto;
  max-width: ${({ size = 256 }) => size}px;
  width: 100%;
  padding: var(--spacing-padding);
`;

export default QRCode;
